import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectImage } from 'actions/chat';
import { viewImage } from 'actions/chat/fileUpload';
import ImageMessage from 'components/chat/fileUpload/ImageMessage';

export default connect(
  (state, ownProps) => ({
    image: ownProps.imageGuid ? state.chat.main.images.get(ownProps.imageGuid) : null
  }),
  (dispatch, ownProps) => bindActionCreators({
    onShowImage: ownProps.imageGuid
      ? selectImage.bind(null, ownProps.imageGuid)
      : viewImage.bind(null, ownProps.imageId),
  }, dispatch)
)(ImageMessage);



// WEBPACK FOOTER //
// ./containers/chat/fileUpload/ImageMessage.js